import {  Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { AddCarModelDictionaryItemComponent } from 'src/app/shared/components/add-car-model-dictionary-item/add-car-model-dictionary-item.component';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { DictionaryDataItem } from 'src/app/shared/model/DictionaryDataItem';
import { CarDictionaryService } from 'src/app/shared/services/car-dictionary.service';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ControlSettings } from '../../ControlSettings';
import { AutoComplete } from '../operators/autocomplete';

@Component({
  selector: 'car-model-combo-select-ctrl',
  templateUrl: './car-model-combo-select.component.html',
  styleUrls: ['./car-model-combo-select.component.scss'],
   providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CarModelComboSelectComponent,
    multi: true
  }]
})
export class CarModelComboSelectComponent implements ControlValueAccessor, OnInit, OnDestroy {

  constructor(protected controlContainer: ControlContainer, 
    private carDictionaryService: CarDictionaryService,
    private customDialogService: CustomDialogService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  
  @ViewChild("carModelDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  @Input() public formControlName: string;
  @Input() public brandControlName: string;
  @Input() caption: string;
   @Input() allowDefineNew = true;

  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false, readonly:false};

  valuesList$: Observable<DictionaryDataItem[]>;
  term$ = new BehaviorSubject<string>('');
  private brandControlSubscription?: Subscription;

  textField  = 'value';
  valueField  = 'value';
  
  selectedBrand:string;

  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    if(this.brandControlName){
      this.selectedBrand = this.controlContainer.control.get(this.brandControlName).value;
      this.brandControlSubscription = this.controlContainer.control
        .get(this.brandControlName)
        ?.valueChanges
        .subscribe((carBrand) => this.setBrand(carBrand));
    }

    this.valuesList$ = this.term$.pipe(
      AutoComplete.autocomplete(500, (term => this.carDictionaryService.getCarModels(this.selectedBrand,term))));
    this.filterChange(this.control.value);
  }

  ngOnDestroy(): void {
    this.brandControlSubscription?.unsubscribe();
  }

  
  defineNewItem(){

    const dialogSettings: CustomDialogSettings = {
      content: AddCarModelDictionaryItemComponent,
      appendTo: this.containerRef,
      maxWidth: '60vw',
      maxHeight: '60vh',
      dialogInputs: {
        selectedBrand : this.selectedBrand
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          const newModel = r['newModel'];
          if(newModel){
            this.filterChange(newModel);
            this.control.setValue(newModel);
          }
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  onChange(value: any) {
    this.valueChangeEvent.emit(value);
  }

  public filterChange(filter: any): void {
      this.term$.next(filter);
  }

  public setBrand(carBrand:string){
    
    if(this.selectedBrand != carBrand){
      this.selectedBrand = carBrand;
      
      this.control.setValue('');
      this.filterChange('');
     
    }
  } 

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    if(obj) {
      this.filterChange(obj);
    }
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }

}


